import css from "./chat_message.module.scss";

export const Separator = () => <span className={css.messageInfoSeparator}>•</span>;
